export enum GeopardImageFormatEnum {
    LAYER = 'image/vnd.jpeg-png',
    CONTOUR = 'image/png'
}
